module.exports = __webpack_public_path__ + "static/media/logo.72aae1bb.svg";